<div class="row">

  <div class="col-md-12">

    <nb-card>

        <nb-card-header>

            <div
                class="d-flex justify-content-between align-items-center">

                <h5 class="mb-0">

                {{ process._id
                    ? 'Editar Proceso'
                    : 'Nuevo Proceso'
                }}

                </h5>

                <div>

                <button
                    nbButton
                    status="success"
                    [disabled]="loading"
                    (click)="save()">

                    <nb-icon
                    icon="save-outline">
                    </nb-icon>

                    Guardar información

                </button>

                <button
                    type="button"
                    nbButton
                    ghost
                    status="basic"
                    (click)="close()">
                    cerrar
                </button>

                </div>

            </div>

        </nb-card-header>

      <nb-card-body>

        <!-- PROCESO -->

        <h6 class="section-title">
          PROCESO
        </h6>

        <div class="row">

          <div class="col-md-6">

            <label>
              Nombre del proceso
            </label>

            <input
              nbInput
              fullWidth
              [(ngModel)]="process.nombreProceso">

          </div>

          <div class="col-md-6">

            <label>
              Fecha de actualización
            </label>

            <input
              nbInput
              fullWidth
              type="date"
              [(ngModel)]="process.fechaActualizacion">

          </div>

        </div>

        <hr>

        <!-- GENERALES -->

        <h6 class="section-title">
          GENERALES
        </h6>

        <div class="alert alert-info">

          ¿Qué obtiene el cliente con este proceso?
          ¿Por qué lo solicita?

        </div>

        <textarea
          nbInput
          fullWidth
          rows="6"
          [(ngModel)]="process.descripcionGeneral">
        </textarea>

        <hr>

        <!-- HERRAMIENTAS -->

        <h6 class="section-title">
          HERRAMIENTAS
        </h6>

        <div
          class="card mb-3"
          *ngFor="let herramienta of process.herramientas; let i = index">

          <div class="card-body">

            <div class="row">

              <div class="col-md-3">

                <label>Tipo</label>

                <select
                  class="form-control"
                  [(ngModel)]="herramienta.tipo">

                  <option value="PLATAFORMA">
                    Plataforma
                  </option>

                  <option value="CORREO">
                    Correo
                  </option>

                  <option value="CRM">
                    CRM
                  </option>

                  <option value="AGENDA">
                    Agenda
                  </option>

                  <option value="DRIVE">
                    Drive
                  </option>

                </select>

              </div>

              <div class="col-md-3">

                <label>Link</label>

                <input
                  class="form-control"
                  [(ngModel)]="herramienta.link">

              </div>

              <div class="col-md-3">

                <label>Usuario</label>

                <input
                  class="form-control"
                  [(ngModel)]="herramienta.usuario">

              </div>

              <div class="col-md-3">

                <label>Contraseña</label>

                <input
                  class="form-control"
                  [(ngModel)]="herramienta.password">

              </div>

            </div>

          </div>

        </div>

        <button
          nbButton
          status="info"
          (click)="process.herramientas.push({
            tipo:'',
            link:'',
            usuario:'',
            password:''
          })">

          <nb-icon icon="plus-outline"></nb-icon>
          Agregar herramienta

        </button>

        <hr>

        <!-- PROCEDIMIENTO -->

      <h6 class="section-title">
          PROCEDIMIENTO
      </h6>

      <div class="row">

          <div
              class="col-lg-4 col-md-6 mb-4"
              *ngFor="
                  let paso of process.procedimiento;
                  let i = index;
                  trackBy: trackByIndex
              ">

              <div class="card h-100 shadow-sm">

                  <div class="card-header d-flex justify-content-between align-items-center">

                      <h6 class="mb-0">

                          <nb-icon icon="list-outline"></nb-icon>

                          Paso {{ i + 1 }}

                      </h6>

                      <button
                          nbButton
                          size="tiny"
                          status="danger"
                          (click)="removeStep(i)">

                          <nb-icon icon="trash-outline"></nb-icon>

                      </button>

                  </div>

                  <div class="card-body">

                      <div class="form-group">

                          <label>Descripción</label>

                          <textarea
                              nbInput
                              fullWidth
                              rows="4"
                              [(ngModel)]="paso.texto">
                          </textarea>

                      </div>

                      <div class="mt-3">

                          <label>Capturas</label>

                          <app-upload-step-images
                              [(images)]="paso.imagenes">
                          </app-upload-step-images>

                      </div>

                  </div>

              </div>

          </div>

      </div>

      <div class="text-center">

          <button
              nbButton
              status="info"
              (click)="addStep()">

              <nb-icon icon="plus-outline"></nb-icon>

              Agregar paso

          </button>

      </div>

        <hr>

        <!-- MENSAJES -->

        <h6 class="section-title">
          MENSAJES O PLANTILLAS
        </h6>

        <div
          class="card mb-3"
          *ngFor="let plantilla of process.plantillas">

          <div class="card-body">

            <div class="row">

              <div class="col-md-3">

                <label>Tipo</label>

                <select
                  class="form-control"
                  [(ngModel)]="plantilla.tipo">

                  <option value="CORREO">
                    Correo
                  </option>

                  <option value="WHATSAPP">
                    WhatsApp
                  </option>

                  <option value="LLAMADA">
                    Llamada
                  </option>

                </select>

              </div>

              <div class="col-md-3">

                <label>Para</label>

                <input
                  class="form-control"
                  [(ngModel)]="plantilla.para">

              </div>

              <div class="col-md-6">

                <label>Mensaje</label>

                <textarea
                  class="form-control"
                  rows="3"
                  [(ngModel)]="plantilla.mensaje">
                </textarea>

              </div>

            </div>

          </div>

        </div>

        <button
          nbButton
          status="info"
          (click)="process.plantillas.push({
            tipo:'',
            para:'',
            mensaje:''
          })">

          <nb-icon icon="plus-outline"></nb-icon>
          Agregar plantilla

        </button>

        <hr>

        <h6 class="section-title">
            CASOS ESPECIALES
        </h6>

        <div
        class="card mb-3"
        *ngFor="
            let caso of process.casosEspeciales;
            let i = index
        ">

        <div class="card-body">

            <div class="row">

            <div class="col-md-4">

                <label>Título</label>

                <input
                class="form-control"
                [(ngModel)]="caso.titulo">

            </div>

            <div class="col-md-7">

                <label>Texto</label>

                <textarea
                class="form-control"
                rows="4"
                [(ngModel)]="caso.texto">
                </textarea>

            </div>

            <div class="col-md-1">

                <button
                nbButton
                status="danger"
                (click)="removeCasoEspecial(i)">

                <nb-icon
                    icon="trash-outline">
                </nb-icon>

                </button>

            </div>

            </div>

        </div>

        </div>

        <button
        nbButton
        status="info"
        (click)="addCasoEspecial()">

        <nb-icon icon="plus-outline"></nb-icon>
        Agregar caso especial

        </button>


        <hr>

        <h6 class="section-title">
            INFORMACIÓN IMPORTANTE
        </h6>

        <div
        class="alert alert-warning">

        Información relevante que el asistente
        debe conocer para operar correctamente
        con este cliente.

        </div>

        <div
        class="card mb-3"
        *ngFor="
            let info of process.informacionImportante;
            let i = index
        ">

        <div class="card-body">

            <div class="row">

            <div class="col-md-4">

                <label>Título</label>

                <input
                class="form-control"
                [(ngModel)]="info.titulo">

            </div>

            <div class="col-md-7">

                <label>Texto</label>

                <textarea
                rows="4"
                class="form-control"
                [(ngModel)]="info.texto">
                </textarea>

            </div>

            <div class="col-md-1">

                <button
                nbButton
                status="danger"
                (click)="removeInformacionImportante(i)">

                <nb-icon
                    icon="trash-outline">
                </nb-icon>

                </button>

            </div>

            </div>

        </div>

        </div>

        <button
        nbButton
        status="info"
        (click)="addInformacionImportante()">

        <nb-icon icon="plus-outline"></nb-icon>
        Agregar información

        </button>

        <hr>

        <h6 class="section-title">
            EXCEPCIONES
        </h6>

        <div
        class="card mb-3"
        *ngFor="
            let excepcion of process.excepciones;
            let i = index
        ">

        <div class="card-body">

            <div class="row">

            <div class="col-md-4">

                <label>Título</label>

                <input
                class="form-control"
                [(ngModel)]="excepcion.titulo">

            </div>

            <div class="col-md-7">

                <label>Texto</label>

                <textarea
                rows="4"
                class="form-control"
                [(ngModel)]="excepcion.texto">
                </textarea>

            </div>

            <div class="col-md-1">

                <button
                nbButton
                status="danger"
                (click)="removeExcepcion(i)">

                <nb-icon
                    icon="trash-outline">
                </nb-icon>

                </button>

            </div>

            </div>

        </div>

        </div>

        <button
        nbButton
        status="info"
        (click)="addExcepcion()">

        <nb-icon icon="plus-outline"></nb-icon>
        Agregar excepción

        </button>
      </nb-card-body>

    </nb-card>

  </div>

</div>